<template>
  <div class="club-hortense-page">
    <h2 class="sr-only">Maquette landing page Club Hortense v4</h2>

    <div class="lp">
      <div class="hero">
        <div class="hero-badge">Accès gratuit · Sans engagement</div>
        <h1>Le Club Hortense : une nouvelle façon de voyager, plus responsable et exclusive</h1>
        <p>Rejoignez 14 000 voyageurs qui accèdent à nos adresses de charme avec des avantages exclusifs à chaque séjour.</p>
        <div class="discount-pill">
          <div class="pct">−10%</div>
          <div class="ptxt">sur votre premier séjour<br>dès l'inscription</div>
        </div>
        <div>
          <button type="button" class="hero-cta" @click="scrollToForm">Rejoindre le club gratuitement</button>
        </div>
        <div class="hero-sub">Inscription en 10 secondes — aucune carte bancaire requise</div>
      </div>

      <div class="lp-content">
        <div class="social-proof">
          <div class="sp-item">
            <div class="sp-num">14 000</div>
            <div class="sp-label">membres actifs</div>
          </div>
          <div class="sp-sep"></div>
          <div class="sp-item">
            <div class="sp-num">300+</div>
            <div class="sp-label">hébergements sélectionnés</div>
          </div>
          <div class="sp-sep"></div>
          <div class="sp-item">
            <div class="sp-num">4,8 / 5</div>
            <div class="sp-label">satisfaction membres</div>
          </div>
        </div>

        <div class="dest-section">
          <div class="section-label">Quelques-unes de nos destinations</div>
          <div class="dest-grid">
            <div class="dest-card">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Occitanie.webp" alt="Occitanie">
              <div class="dest-overlay">
                <div class="dest-name">Occitanie</div>
                <div class="dest-sub">Nouvelle-Aquitaine</div>
              </div>
            </div>
            <div class="dest-card">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/Corse.webp" alt="Corse">
              <div class="dest-overlay">
                <div class="dest-name">Corse</div>
                <div class="dest-sub">Méditerranée</div>
              </div>
            </div>
            <div class="dest-card">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Provence-Alpes-Co%CC%82te-d%E2%80%99Azur.webp" alt="Provence">
              <div class="dest-overlay">
                <div class="dest-name">Provence</div>
                <div class="dest-sub">Sud de France</div>
              </div>
            </div>
            <div class="dest-card">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Normandie.webp" alt="Normandie">
              <div class="dest-overlay">
                <div class="dest-name">Normandie</div>
                <div class="dest-sub">Nord de France</div>
              </div>
            </div>
          </div>
        </div>

        <div class="benefits">
          <div class="section-label">Ce que vous obtenez en rejoignant le Club Hortense</div>
          <div class="benefits-grid">
            <div class="benefit">
              <div class="d-flex align-items-center">
                <div class="benefit-icon">
                  <svg viewBox="0 0 16 16" fill="none"><path d="M8 2L10 6L14 6.5L11 9.5L11.5 14L8 12L4.5 14L5 9.5L2 6.5L6 6L8 2Z" stroke="#3B6D11" stroke-width="1.2"/></svg>
                </div>
                <div class="highlight ml-2">−10% dès le 1er séjour</div>
              </div>
              <h3>Tarifs membres exclusifs</h3>
              <p><span class="raleway-semi-p13">Profitez de −10 % sur votre première réservation, puis accédez à des tarifs négociés, exclusivement réservés à nos membres.</span> Offres long week-end, séjours prolongés… chaque escapade devient une opportunité de voyager mieux, au meilleur prix.</p>
            </div>
            <div class="benefit">
              <div class="benefit-icon">
                <svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="#3B6D11" stroke-width="1.2"/><path d="M8 5.5V8L10 9.5" stroke="#3B6D11" stroke-width="1.2" stroke-linecap="round"/></svg>
              </div>
              <h3>Services offerts à l'arrivée</h3>
              <p><span class="raleway-semi-p13">Surclassement, petit-déjeuner, late check-out/ early check-in, bouteille de champagne, massages…</span> Autant d’attentions exclusives offertes qui vous attendent dans chacun de nos 300+ établissements partenaires, pour sublimer chaque séjour.</p>
            </div>
            <div class="benefit">
              <div class="benefit-icon">
                <svg viewBox="0 0 16 16" fill="none"><path d="M8 2C5.24 2 3 4.24 3 7c0 4 5 8 5 8s5-4 5-8c0-2.76-2.24-5-5-5z" stroke="#3B6D11" stroke-width="1.2"/></svg>
              </div>
              <h3>Sélection curatée & durable</h3>
              <p><span class="raleway-semi-p13">Plus de 300 adresses rigoureusement sélectionnées selon nos critères éco-responsables.</span> Et accédez en avant-première à nos nouvelles pépites, réservées à nos membres. Voyagez bien, voyagez mieux dans des lieux qui ont du sens.</p>
            </div>
          </div>
        </div>

        <div class="testimonials">
          <div class="section-label">Ils ont rejoint le Club Hortense</div>
          <div class="t-grid">
            <div class="tcard">
              <div class="t-hotel">Le Manoir d'Hautegente</div>
              <div class="t-quote">« Un week-end de rêve dans ce manoir exceptionnel. Grâce au Club, j'ai eu le petit-déjeuner offert et un accès au spa inclus. Une expérience inoubliable dans un cadre qui dépasse tout ce qu'on peut imaginer. »</div>
              <div class="t-author">
                <div class="t-avatar">CM</div>
                <div>
                  <div class="t-name">Claire M.</div>
                  <div class="t-detail">Membre depuis mars 2025 · Lyon</div>
                </div>
                <div class="t-stars">★★★★★</div>
              </div>
            </div>
            <div class="tcard">
              <div class="t-hotel">Le Domaine de la Corniche</div>
              <div class="t-quote">« Vue sur la Seine à couper le souffle, chambre sublime et tarif membre vraiment avantageux. Je n'aurais jamais trouvé cette adresse sans Hortense. Le Club, c'est la garantie de ne jamais se tromper. »</div>
              <div class="t-author">
                <div class="t-avatar">TR</div>
                <div>
                  <div class="t-name">Thomas R.</div>
                  <div class="t-detail">Membre depuis janvier 2026 · Paris</div>
                </div>
                <div class="t-stars">★★★★★</div>
              </div>
            </div>
            <div class="tcard">
              <div class="t-hotel">Le Domaine du Ferret</div>
              <div class="t-quote">« Grâce au Club, nous avons été surclassés à notre arrivée et accueillis avec un apéritif de bienvenue. Une attention qui a rendu notre séjour encore plus spécial. Je ne réserve plus qu’avec Hortense. »</div>
              <div class="t-author">
                <div class="t-avatar">SM</div>
                <div>
                  <div class="t-name">Sophie M.</div>
                  <div class="t-detail">Membre depuis septembre 2025 · Bordeaux</div>
                </div>
                <div class="t-stars">★★★★★</div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section" ref="signupFormSection">
          <form class="form-box" @submit.prevent="handleEmailSignUp">
            <div class="form-title">Créer mon accès gratuit</div>
            <div class="form-sub">Rejoignez le Club Hortense en 10 secondes</div>
            <div class="form-highlight">
              <div class="fh-badge">−10%</div>
              <div class="fh-text">sur votre premier séjour, automatiquement appliqué après inscription</div>
            </div>
            <button type="button" class="google-btn" @click="signUpWithGoogle">
              <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/google.png" style="height: 20px;" v-set-alt>
              Continuer avec Google
            </button>
            <div class="form-divider"><span>ou par email</span></div>
            <p v-if="errorText" class="form-feedback form-feedback-error">{{ errorText }}</p>
            <p v-if="successText" class="form-feedback form-feedback-success">{{ successText }}</p>
            <div class="form-row">
              <div class="form-field">
                <label>Prénom</label>
                <input v-model.trim="userInfo.first_name" type="text" placeholder="Sophie" required>
              </div>
              <div class="form-field">
                <label>Nom</label>
                <input v-model.trim="userInfo.last_name" type="text" placeholder="Martin" required>
              </div>
            </div>
            <div class="form-full">
              <label>Adresse email</label>
              <input v-model.trim="userInfo.email" type="email" placeholder="sophie@email.com" required>
            </div>
            <div class="form-full">
              <label>Mot de passe</label>
              <input v-model="userInfo.password" type="password" placeholder="12 caractères minimum" required>
            </div>
            <button type="submit" class="form-submit hortense-btn-primary" :disabled="isSubmitting">
              {{ isSubmitting ? 'Inscription en cours...' : 'Rejoindre le Club & obtenir −10% →' }}
            </button>
            <div class="form-legal">En vous inscrivant, vous acceptez de recevoir nos offres exclusives. Désabonnement à tout moment. La réduction de 10% est valable sur votre première réservation via Hortense.</div>
          </form>
        </div>

        <div class="footer-strip">
          <div class="footer-item"><div class="footer-dot"></div>Inscription gratuite · sans engagement</div>
          <div class="footer-item"><div class="footer-dot"></div>Données protégées · RGPD</div>
          <div class="footer-item"><div class="footer-dot"></div>Aucune carte requise</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';

export default {
  name: 'RejoindreClubHortense',
  data() {
    return {
      userInfo: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        newsletter: true,
      },
      isSubmitting: false,
      errorText: null,
      successText: null,
    };
  },
  methods: {
    scrollToForm() {
      const formSection = this.$refs.signupFormSection;
      if (!formSection) return;
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    signUpWithGoogle() {
      window.location.href = '/users/auth/google_oauth2';
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    async submitSignupToFormspree() {
      const FORMSPREE_ID = 'xrejrvve';
      const formspreeData = {
        first_name: this.userInfo.first_name,
        last_name: this.userInfo.last_name,
        email: this.userInfo.email,
        newsletter: this.userInfo.newsletter,
        signup_source: 'RejoindreClubHortense',
      };

      try {
        await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formspreeData),
        });
      } catch (error) {
        console.error('Formspree signup tracking failed:', error);
      }
    },
    async handleEmailSignUp() {
      this.errorText = null;
      this.successText = null;

      if (!this.validateEmail(this.userInfo.email)) {
        this.errorText = 'Email incorrect';
        return;
      }
      if (this.userInfo.password.length < 12) {
        this.errorText = 'Le mot de passe doit contenir 12 caractères minimum';
        return;
      }

      this.isSubmitting = true;
      try {
        await fetcher.post('/users/', {
          user: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            email: this.userInfo.email,
            password: this.userInfo.password,
            password_confirmation: this.userInfo.password,
            newsletter: this.userInfo.newsletter,
          },
        });

        await this.submitSignupToFormspree();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          method: 'email_password',
        });

        this.successText = 'Compte créé avec succès. Redirection...';
        window.location.replace('/');
      } catch (e) {
        this.errorText = 'Cet email est déjà utilisé';
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400&family=Raleway:wght@300;400;500;600&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.lp { width: 100%; background: var(--color-background-primary); border: 0.5px solid var(--color-border-tertiary); border-radius: var(--border-radius-lg); overflow: hidden; }

.lp-content { width: 100%; max-width: 100%; padding-right: 12%; padding-left: 12%; }

.hero { background: #3B6152; padding: 52px 40px 44px; text-align: center; }
.hero-logo { font-family: 'Raleway', sans-serif; font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.45); letter-spacing: 0.25em; margin-bottom: 28px; }
.hero-badge { display: inline-block; border: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.75); font-family: 'Raleway', sans-serif; font-size: 10px; font-weight: 400; letter-spacing: 0.12em; padding: 5px 16px; border-radius: 20px; margin-bottom: 22px; }
.hero h1 { font-family: 'Merriweather', serif; font-size: 32px; font-weight: 300; color: #fff; line-height: 1.35; max-width: 680px; margin: 0 auto 14px; }
.hero p { font-family: 'Raleway', sans-serif; font-size: 15px; font-weight: 400; color: rgba(255,255,255,0.6); max-width: 500px; margin: 0 auto 28px; line-height: 1.75; letter-spacing: 0.02em; }

.discount-pill { display: inline-flex; align-items: center; gap: 12px; background: #3b6152; border: 1px solid #fff; border-radius: 6px; padding: 12px 22px; margin-bottom: 28px; }
.discount-pill .pct { font-family: 'Merriweather', serif; font-size: 28px; font-weight: 400; color: #9FE1CB; line-height: 1; }
.discount-pill .ptxt { font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 300; color: rgba(255,255,255,0.7); text-align: left; line-height: 1.5; letter-spacing: 0.03em; }

.hero-cta { background: #fff; color: #3B6152; border: none; padding: 13px 36px; border-radius: 2px; font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 500; letter-spacing: 0.12em; cursor: pointer; display: inline-block; text-transform: uppercase; }
.hero-sub { font-family: 'Raleway', sans-serif; font-size: 12px; font-weight: 300; color: rgba(255,255,255,0.35); margin-top: 12px; letter-spacing: 0.04em; }

.social-proof { display: flex; align-items: center; justify-content: center; gap: 20px; padding: 16px 40px; border-bottom: 0.5px solid var(--color-border-tertiary); background: #EBEAE5; flex-wrap: wrap; }
.sp-item { display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 0 6px; }
.sp-num { font-family: 'Merriweather', serif; font-size: 20px; font-weight: 400; color: var(--color-text-primary); }
.sp-label { font-family: 'Raleway', sans-serif; font-size: 12px; font-weight: 400; color: var(--color-text-secondary); letter-spacing: 0.04em; }
.sp-sep { width: 1px; height: 28px; background: #c7c7c7; }

.dest-section { padding: 40px 40px 32px; }
.section-label { font-family: 'Merriweather', serif; font-size: 22px; font-weight: 400; color: var(--color-text-secondary); text-align: center; margin-bottom: 18px; }
.dest-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.dest-card { border-radius: 3px; overflow: hidden; position: relative; height: 150px; }
.dest-card img { width: 100%; height: 100%; object-fit: cover; display: block; }
.dest-overlay { position: absolute; bottom: 0; left: 0; right: 0; padding: 10px 12px; background: linear-gradient(transparent, rgba(0,0,0,0.7)); }
.dest-name { font-family: 'Merriweather', serif; font-size: 13px; font-weight: 300; color: #fff; }
.dest-sub { font-family: 'Raleway', sans-serif; font-size: 11px; font-weight: 400; color: rgba(255,255,255,0.65); letter-spacing: 0.06em; margin-top: 2px; }

.benefits { padding: 8px 40px 32px; }
.benefits-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.benefit { padding: 20px; border: 1px solid #7070704E; border-radius: 8px; background: #fff; }
.benefit-icon { width: 30px; height: 30px; background: #EAF3DE; border-radius: 6px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.benefit-icon svg { width: 15px; height: 15px; }
.benefit .highlight { display: inline-block; height: fit-content; background: #EAF3DE; color: #3B6D11; font-family: 'Raleway', sans-serif; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 2px; margin-bottom: 8px; letter-spacing: 0.06em; }
.benefit h3 { font-family: 'Merriweather', serif; font-size: 18px; font-weight: 400; color: var(--color-text-primary); margin-bottom: 8px; line-height: 1.4; }
.benefit p { font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 300; color: var(--color-text-secondary); line-height: 1.65; letter-spacing: 0.01em; }

.testimonials { padding: 0 40px 36px; }
.t-grid { display: grid; grid-template-columns: 1fr; gap: 12px; }
.tcard { background: #EBEAE5; border-radius: 3px; padding: 20px 24px; }
.t-hotel { font-family: 'Raleway', sans-serif; font-size: 11px; font-weight: 600; color: #3B6D11; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 10px; }
.t-quote { font-family: 'Merriweather', serif; font-size: 16px; font-weight: 300; color: var(--color-text-primary); line-height: 1.75; margin-bottom: 14px; }
.t-author { display: flex; align-items: center; gap: 10px; }
.t-avatar { width: 32px; height: 32px; border-radius: 50%; background: #1a2e1e; display: flex; align-items: center; justify-content: center; font-family: 'Raleway', sans-serif; font-size: 11px; font-weight: 500; color: #fff; flex-shrink: 0; }
.t-name { font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 500; color: var(--color-text-primary); }
.t-detail { font-family: 'Raleway', sans-serif; font-size: 12px; font-weight: 300; color: var(--color-text-secondary); letter-spacing: 0.02em; }
.t-stars { color: #BA7517; font-size: 12px; margin-left: auto; }

.form-section { margin: 0 40px 36px; }
.form-box { border: 1px solid #e5e3df; border-radius: 3px; padding: 28px 32px; background: var(--color-background-primary); }
.form-title { font-family: 'Merriweather', serif; font-size: 22px; font-weight: 400; color: var(--color-text-primary); margin-bottom: 4px; text-align: center; }
.form-sub { font-family: "Merriweather Light", "serif"; font-size: 18px; font-weight: 300; color: var(--color-text-secondary); text-align: center; margin-bottom: 18px; letter-spacing: 0.03em; }
.form-highlight { background: #EAF3DE; border-radius: 3px; padding: 11px 16px; display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
.fh-badge { background: #1a2e1e; color: #9FE1CB; font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 600; padding: 5px 10px; border-radius: 2px; white-space: nowrap; letter-spacing: 0.05em; }
.fh-text { font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 400; color: #27500A; line-height: 1.5; }
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 10px; }
.form-field label { display: block; font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 500; letter-spacing: 0.08em; text-transform: uppercase; color: var(--color-text-secondary); margin-bottom: 5px; }
.form-field input { width: 100%; padding: 10px 12px; border: 1px solid #7070704E; border-radius: 8px; font-family: 'Raleway', sans-serif; font-size: 14px; font-weight: 400; background: var(--color-background-primary); color: var(--color-text-primary); transition: border-color 0.3s ease; outline: none; }
.form-full { margin-bottom: 10px; }
.form-full label { display: block; font-family: 'Raleway', sans-serif; font-size: 13px; font-weight: 500; letter-spacing: 0.08em; text-transform: uppercase; color: var(--color-text-secondary); margin-bottom: 5px; }
.form-full input { width: 100%; padding: 10px 12px; border: 1px solid #7070704E; border-radius: 8px; font-family: 'Raleway', sans-serif; font-size: 14px; font-weight: 400; background: var(--color-background-primary); color: var(--color-text-primary); transition: border-color 0.3s ease; outline: none; }
.form-field input:focus, .form-full input:focus { border-color: #3B6152; }
.form-field input::placeholder, .form-full input::placeholder { color: #999; }
.form-submit { width: 100%; padding: 16px 36px; border-radius: 4px; font-family: 'Raleway', sans-serif; cursor: pointer; margin-top: 16px; }
.form-legal { font-family: 'Raleway', sans-serif; font-size: 11px; font-weight: 400; color: var(--color-text-tertiary); text-align: center; margin-top: 10px; line-height: 1.6; letter-spacing: 0.02em; }
.form-divider { display: flex; align-items: center; text-align: center; margin: 20px 0; }
.form-divider span {
  font-family: 'Raleway', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #5D6561;
  letter-spacing: 1px;
  white-space: nowrap;
}
.form-divider::before,
.form-divider::after {
  content: '';
  flex: 1;
  border-top: 1px solid #e5e3df;
}
.form-divider::before { margin-right: 12px; }
.form-divider::after { margin-left: 12px; }
.google-btn {
  width: 100%;
  border: 1px solid #7070704E;
  background: #fff;
  color: var(--color-text-primary);
  padding: 11px 12px;
  border-radius: 8px;
  font-family: 'Raleway', sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: border-color 0.3s ease, background-color 0.2s ease;
}

.google-btn svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.google-btn:hover {
  background: #f8faf8;
}

.google-btn:focus {
  outline: none;
  border-color: #3B6152;
}
.form-feedback { font-family: 'Raleway', sans-serif; font-size: 13px; line-height: 1.5; margin-bottom: 10px; }
.form-feedback-error { color: #b3261e; }
.form-feedback-success { color: #1e7a32; }
.form-submit:disabled { opacity: 0.7; cursor: not-allowed; }

.footer-strip { padding: 16px 40px; border-top: 0.5px solid var(--color-border-tertiary); display: flex; align-items: center; justify-content: center; gap: 24px; flex-wrap: wrap; }
.footer-item { font-family: 'Raleway', sans-serif; font-size: 12px; font-weight: 400; color: var(--color-text-tertiary); display: flex; align-items: center; gap: 6px; letter-spacing: 0.03em; }
.footer-dot { width: 4px; height: 4px; border-radius: 50%; background: #3B6D11; flex-shrink: 0; }

@media (max-width: 520px) {
  .hero, .dest-section, .benefits, .testimonials { padding-left: 20px; padding-right: 20px; }
  .form-section { margin-left: 20px; margin-right: 20px; }
  .dest-grid { grid-template-columns: repeat(2, 1fr); }
  .benefits-grid { grid-template-columns: 1fr; }
  .form-row { grid-template-columns: 1fr; }
  .hero h1 { font-size: 24px; }
  .form-box { padding: 22px 20px; }
  .section-label { font-family: 'Merriweather', serif; font-size: 20px; }
  .form-submit { font-size: 13px; }

  .club-hortense-page {
    margin-top: 8rem;
  }

  .lp-content {
    padding: unset;
  }
}
</style>
